import React, { HTMLProps } from 'react';
import { Link } from 'react-router-dom';
import { staticConfig } from '../../config/static';
import styles from './customLink.module.scss';

export interface ICustomLinkProps extends HTMLProps<HTMLAnchorElement> {
    variant?: 'primary' | 'secondary' | 'light' | 'dark';
    to?: string;
    disableContextMenu?: boolean;
    disabled?: boolean;
}

const { defaultUrl } = staticConfig;

export const CustomLink = ({
    href = defaultUrl,
    variant = 'primary',
    disableContextMenu = true,
    disabled = false,
    ...props
}: ICustomLinkProps) => {
    const getOnClick = () => {
        const isEmptyLink = href === defaultUrl;
        return {
            onClick: isEmptyLink
                ? (event: React.MouseEvent<HTMLAnchorElement>) => {
                      event.preventDefault();
                      props.onClick(event);
                  }
                : props.onClick,
            onKeyDown: (event: React.KeyboardEvent<HTMLAnchorElement>) =>
                props.onKeyDown ? props.onKeyDown(event) : event.key === 'Enter' && event.currentTarget.click(),
        };
    };
    return props.to ? (
        <Link
            to={props.to}
            className={`${props.className || ''} ${styles.customLink} ${styles[variant]}`}
            {...(disableContextMenu && { onContextMenu: (e) => e.preventDefault() })}
        >
            {props.children}
        </Link>
    ) : (
        <a
            {...props}
            href={href}
            className={getClassName()}
            {...(props.onClick && getOnClick())}
            {...(disableContextMenu && { onContextMenu: (e) => e.preventDefault() })}
        >
            {props.children}
        </a>
    );

    function getClassName(): string {
        return disabled
            ? `${props.className || ''} ${styles.disabled} ${styles[variant]}`
            : `${props.className || ''} ${styles.customLink} ${styles[variant]}`;
    }
};
